// extracted by mini-css-extract-plugin
module.exports = {"iconArrow":"_1L0ra3fK99D10PHKbHWqyj"};